(function($){
	$.validator.setDefaults({
		highlight: function (element) {
			$(element).closest('.required').removeClass('has-success').addClass('has-error');
		},
		unhighlight: function (element) {
			$(element).closest('.required').removeClass('has-error');
		}
	});
	$(document).ready(function($) {
		$('#engage-with-us').validate({
			submitHandler: function(form) {
				$('body').addClass('overlay-in');
				var data = $(form).serialize();
				data = data + "&action=engage-with-us-mail";
				$.ajax({
					url: window.TiCf.ajaxUrl,
					method: "POST",
					data: data,
					dataType: "json",
					error:function(error){
						$('body').removeClass('overlay-in');
						$('#message-cn').empty().append('<div class="alert alert-danger alert-dismissible fade" role="alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button><strong>Error!</strong> There was an error. Please try again later. That’s all we know.</div>');
						$('html, body').animate({
							scrollTop: $("#message-cn").offset().top - 15
						}, 200, function(){
							$('#message-cn .alert').addClass('in');
						});
					},
					success: function(response) {
						$('body').removeClass('overlay-in');
						var m = '';
						if(response){
							m = '<div class="alert alert-success alert-dismissible fade" role="alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button><strong>Ok!</strong> Your message was sent successfully.</div>';
						}else{
							m = '<div class="alert alert-warning alert-dismissible fade" role="alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button><strong>Warning!</strong> There was an error. Please try again later. That’s all we know.</div>';
						}
						$('#message-cn').empty().append(m);
						$('html, body').animate({
							scrollTop: $("#message-cn").offset().top - 15
						}, 200, function(){
							$('#message-cn .alert').addClass('in');
						});
						$('#engage-with-us')[0].reset();
					}
				});
			}
		});
		$('form[novalidate="novalidate"] .required input[type="text"].form-control').each(function(){
			$(this).rules('add', {
				required : true
			});
		});

		$('form[novalidate="novalidate"] .required input[type="email"].form-control').each(function(){
			$(this).rules('add', {
				required: true,
				email: true
			});
		});

		$('form[novalidate="novalidate"] .required input[data-min].form-control').each(function(){
			$(this).rules('add', {
				minlength: $(this).data('min'),
				maxlength: $(this).data('min'),
				number: true
			});
		});
	});
})(jQuery);

(function () {
	const form = document.forms['engage-with-us'];

	if ( ! form ) {
		return;
	}

	const optionalSection = form.querySelector( '.form-group--optional' );
	const formFooter = form.querySelector( 'footer' );

	if ( ! optionalSection ) {
		return;
	}

	form.querySelectorAll( '[name="profession"]' ).forEach( function ( el ) {
		el.addEventListener( 'change', function () {
			const who = form.querySelector( '[name="profession"]:checked' ).value;
			const visibleWhen = 'Greenspace Planner';

			toggleOptionalSection( optionalSection, who === visibleWhen );

			if ( visibleWhen === who ) {
				formFooter.querySelector( 'div' ).setAttribute( 'hidden', '' );
				formFooter.querySelector( '[data-for]' ).removeAttribute( 'hidden' );
			} else {
				formFooter.querySelector( 'div' ).removeAttribute( 'hidden' );
				formFooter.querySelector( '[data-for]' ).setAttribute( 'hidden', '' );
			}
		} );
	} );

	function toggleOptionalSection( section, show ) {
		if ( show ) {
			section.removeAttribute( 'hidden' );
			section.querySelectorAll( '[data-required]' ).forEach( function ( el ) {
				el.setAttribute( 'required', '' );
			} );
		} else {
			section.setAttribute( 'hidden', '' );
			section.querySelectorAll( '[required]' ).forEach( function ( el ) {
				el.setAttribute( 'data-required', '' );
				el.removeAttribute( 'required' );
			} );
		}
	}
}());
